__turbopack_context__.v({
  "done": "_2r0Oza_done",
  "peg": "_2r0Oza_peg",
  "progressBar": "_2r0Oza_progressBar",
  "track": "_2r0Oza_track",
});
